module.exports = __webpack_public_path__ + "static/0.0_Homepage_Animation-9fcedf2a5b4d1cfba7436db0b2ecb9bd.mp4";